import styled from 'styled-components';

export const LoginContainerStyled = styled.div`

`;
